import React from "react";
import { View, StyleSheet } from "react-native";
import NtMarketingPageContainer from "../components/general/NtMarketingPageContainer";
import BaseMarketingController from "./BaseMarketingController";
import NtVoxcraftAbout from "../components/voxcraft/NtVoxcraftAbout";
import NtVoxcraftTrustMarquee from "../components/voxcraft/NtVoxcraftTrustMarquee";
import NtVoxcraftCtaStrip from "../components/voxcraft/NtVoxcraftCtaStrip";

class AboutUsController extends BaseMarketingController {
  state = {};

  componentDidMount() {
    super.componentDidMount && super.componentDidMount();
    if (typeof document !== "undefined") {
      document.title = "About | Voxcraft";
    }
  }

  render() {
    return (
      <NtMarketingPageContainer>
        <View style={styles.container}>
          <NtVoxcraftAbout />
          <NtVoxcraftTrustMarquee />
          <NtVoxcraftCtaStrip />
        </View>
      </NtMarketingPageContainer>
    );
  }
}

const styles = StyleSheet.create({
  container: {},
});

export default AboutUsController;
